export default __webpack_public_path__ + "static/media/tip.3a58ad01.svg";